module.exports = "/assets/data/9347a80160a1d224d83dfcdfd8ed7ce8-MK12.data.json";